import React, { useCallback, FunctionComponent, useState } from 'react'
import { Wizard, WizardStep } from 'components'
import {
  BookingFields,
  validationSchema as bookingValidation,
} from './BookingFields'
import {
  VehicleFields,
  validationSchema as vehicleValidation,
} from './VehicleFields'
import {
  SummaryFields,
  validationSchema as summaryValidation,
} from './SummaryFields'
import { useVehicles } from 'api'
import { NewBooking, UpdatedBooking } from 'api/types'
import { FormikHelpers } from 'formik'

const initialValues: NewBooking = {
  startDate: '',
  endDate: '',
  pickUpStationId: '',
  dropOffStationId: '',
  vehicleId: '',
  vehicleCount: 1,
  acceptTerms: false,
}

/**
  Ideally we would read the dates from the form state directly,
    (which we can't because this is above the form)
  or have a loader component between the Wizard and WizardSteps that need the vehicles
    (which we can't because only WizardsSteps can be children of Wizard)

  So instead sync the state to here
*/

const useDateVehicles = () => {
  const [dates, setDates] = useState({ startDate: '', endDate: '' })
  const updateDates = useCallback((d: any) => setDates(d), [setDates])
  const { data: vehicles } = useVehicles(dates)
  return { vehicles, setDates: updateDates }
}

interface BookingFormProps {
  onSubmit: (
    values: NewBooking | UpdatedBooking,
    formikHelpers: FormikHelpers<NewBooking | UpdatedBooking>
  ) => void
  booking?: UpdatedBooking
}

export const BookingForm: FunctionComponent<BookingFormProps> = ({
  onSubmit,
  booking,
}) => {
  const { vehicles, setDates } = useDateVehicles()
  return (
    <Wizard initialValues={booking || initialValues} onSubmit={onSubmit}>
      <WizardStep
        name="pages.bookings.bookingForm.bookingForm.bookingDates"
        validationSchema={bookingValidation}
      >
        <BookingFields setVehicleDates={setDates} />
      </WizardStep>
      <WizardStep
        name="pages.bookings.bookingForm.bookingForm.vehicleSelection"
        validationSchema={vehicleValidation}
      >
        <VehicleFields vehicles={vehicles || []} />
      </WizardStep>
      <WizardStep
        name="pages.bookings.bookingForm.bookingForm.summary"
        validationSchema={summaryValidation}
      >
        <SummaryFields vehicles={vehicles || []} />
      </WizardStep>
    </Wizard>
  )
}
